<script setup lang="ts">
  import { computed } from 'vue';
  import { ColoredButton } from '@/shared/ui';

  const props = defineProps<{
    hasFiles: boolean;
    filesLoaded: boolean;
    isUploading?: boolean;
    allUrlsValid?: boolean;
    allChangelogsFilled?: boolean;
    hasBatchDuplicatePrefixes?: boolean;
    hasDbPrefixConflict?: boolean;
    isCheckingPrefixConflicts?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'confirm'): void;
  }>();

  const isSubmitDisabled = computed(() => {
    if (props.isUploading) {
      return true;
    }

    if (props.hasBatchDuplicatePrefixes) {
      return true;
    }

    if (props.hasDbPrefixConflict || props.isCheckingPrefixConflicts) {
      return true;
    }

    const urlsAreValid = props.allUrlsValid !== undefined ? props.allUrlsValid : true;

    const changelogsAreFilled =
      props.allChangelogsFilled !== undefined ? props.allChangelogsFilled : true;

    if (props.allUrlsValid !== undefined) {
      return !urlsAreValid || !changelogsAreFilled;
    }

    return !props.hasFiles || !changelogsAreFilled;
  });
</script>

<template>
  <div
    id="upload-actions-wrapper"
    class="flex justify-end gap-6 pr-4 pb-1.5"
  >
    <ColoredButton
      text="Cancelar"
      :outlined="true"
      border-color="gray-03"
      color="gray-07"
      icon-alt="Cancelar"
      @click="emit('close')"
    />
    <ColoredButton
      :disabled="isSubmitDisabled"
      disabled-color="light-gray-xx-02"
      :text="isUploading ? 'Enviando...' : 'Enviar para aprovação'"
      :icon-alt="isUploading ? 'Enviando...' : 'Enviar para aprovação'"
      @click="emit('confirm')"
    />
  </div>
</template>
